module.exports = __webpack_public_path__ + "img/immunization-tracking-button.0b41efe4.png";